module.exports = __webpack_public_path__ + "static/media/gado_register_user.a186d11d.jpg";